import { DEFAULT_LANGUAGE_CODE, SUPPORTED_LANGUAGES } from "../constants";

export const getBrowserLanguageCode = (lngCode: string): string => {
  let code = DEFAULT_LANGUAGE_CODE;

  SUPPORTED_LANGUAGES.forEach((language) => {
    if (Object.values(language.languageCodes).includes(lngCode)) {
      code = language.code;
    }
  });

  return code;
};
